import { useTranslation } from 'react-i18next';
import { DpoTable } from "./DpoTable";

// TODO: probably a redundant component, as DpoTable exists
export function Dpo() {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col gap-[10px]">
      <DpoTable />
    </div>
  );
}